import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

const BASE = serviceName + '/learning/courseCategory'

export function getCourseCategoryPage(data) {
  return request({
    url: BASE + '/page',
    method: 'post',
    data,
  })
}

export function getCourseCategoryList(data) {
  return request({
    url: BASE + '/list',
    method: 'post',
    data,
  })
}

export function addCourseCategory(data) {
  return request({
    url: BASE + '/add',
    method: 'post',
    data,
  })
}

export function updateCourseCategory(data) {
  return request({
    url: BASE + '/update',
    method: 'post',
    data,
  })
}

export function deleteCourseCategory(id) {
  return request({
    url: BASE + '/delete/' + id,
    method: 'post',
  })
}

export function updateCourseCategoryStatus(id, status) {
  return request({
    url: BASE + '/status/' + id,
    method: 'post',
    params: { status },
  })
}

export function getCourseCategoryDetail(id) {
  return request({
    url: BASE + '/detail/' + id,
    method: 'get',
  })
}